import { useEffect } from 'react';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga4';
import appSubPath from './utils/helper';
import Urls from './utils/util';
import './css/toggle.css';
import './css/username.css';

// Pages Imports
import AddNode from './screens/addNode/addNode';
import ErrorScreen from './screens/error/error';
import Landing from './screens/networksList/landing';
import NetworkSelectionZone from './screens/createNetwork/createNetwork';
import CreateStakingNetworks from './screens/createStakingNetwork/createStakingNetwork';
import DedicatedNode from './screens/dedicatedNode/dedicated';
import EndpointDetailsMatrics from './screens/endpointDetailsMetrics/endpointDetailsMetrics';
import Layout from './components/layout/layout';

function App() {
  const path1 = appSubPath('/errorscreen');
  const path3 = appSubPath('/nodes/full/deploy');
  const path2 = appSubPath('/nodes/full/:id');
  const path4 = appSubPath('/nodes/full/:id/add');
  const path5 = appSubPath('/nodes/validator/deploy');
  const path6 = appSubPath('/nodes/full/purchase');
  const path7 = appSubPath('/nodes/validator/purchase');
  const path9 = appSubPath('/endpoints/:id');
  const pathValidatorDetails = appSubPath('/nodes/validator/:id');

  useEffect(() => {
    ReactGA.initialize('GTM-KMMVTKT');
    if (Urls.getEnvironment() === 'production') {
      ReactGA.send(window.location.pathname + window.location.search);
    }
  }, []);

  return (
    <Layout>
      <div className="App">
        <Helmet>
          <title>{Urls.getAppTitle()}</title>
        </Helmet>
        <BrowserRouter>
          <Routes>
          <Route path={path1} element={<ErrorScreen />} />
          <Route path={path3} element={<NetworkSelectionZone />} />
          <Route path={path5} element={<CreateStakingNetworks />} />
          <Route path={path2} element={<Landing />} />
          <Route path={path4} element={<AddNode />} />
          <Route path={path6} element={<DedicatedNode />} />
          <Route path={path7} element={<DedicatedNode />} />
          <Route path={path9} element={<EndpointDetailsMatrics />} />
          <Route path={pathValidatorDetails} element={<Landing />} />
          <Route path="*" element={<Navigate to={path6} replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </Layout>
  );
}

export default App;
